import React from 'react';
import PropTypes from 'prop-types';

import { Button, Icon, Popup } from 'semantic-ui-react';
/**
 * Base popup button for all filters
 */
export default class PopupFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    handleClick() {
        if (this.props.value) {
            // clear value
            return this.props.clear();
        }

        this.setState({
            open: !this.state.open
        });
    }

    componentDidUpdate(previousProps) {
        if (this.props.controlled) {
            if (!previousProps.open && this.props.open) {
                this.setState({
                    open: false
                });
            }
            return;
        }

        if (!previousProps.value && this.props.value) {
            this.setState({
                open: false
            });
        }
    }

    close() {
        let open = false;
        if (this.props.controlled) {
            open = this.props.onClose();
        }

        this.setState({ open });
    }

    render() {
        let { className, children, label, buttonProps, wide } = this.props;
        let content = buttonProps.label ? (
            <React.Fragment>
                <Icon name="delete" /> {label}
            </React.Fragment>
        ) : (
            label
        );
        return (
            <Popup
                className={className}
                content={children}
                on="click"
                open={this.props.open === false ? false : this.state.open}
                onOpen={this.handleClick.bind(this)}
                onClose={() => this.close()}
                position="bottom center"
                trigger={<Button basic={buttonProps.basic || true} content={content} {...buttonProps} />}
                wide={wide || false}
            />
        );
    }
}

PopupFilter.defaultProps = {
    className: '',
    controlled: false,
    buttonProps: {},
    wide: null,
    clear: () => {},
    open: true,
    onClose: () => false
};

PopupFilter.propTypes = {
    clear: PropTypes.func,
    controlled: PropTypes.bool,
    value: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.node,
    label: PropTypes.string,
    buttonProps: PropTypes.object,
    wide: PropTypes.bool,
    open: PropTypes.bool,
    onClose: PropTypes.func
};
